<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md12 class="content-title">
                <h2>Perguntas Frequentes</h2>
                <h4>Não encontrou o que precisava? Previsul Soluciona: atendimento via WhatsApp (51) 98268-0607 ou e-mail soluciona@previsul.com.br.</h4>
            </v-flex>
        </v-layout>

        <v-flex md12>
            <br>
            <div class="line"></div>
        </v-flex>

        <v-layout row class="content-body overflow-y-auto">
            <v-flex md5>
                <br>
                <h2>Geral</h2>
                Questões gerais
                <br>
                <br>
                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header><strong>Onde posso gerar 2ª Via Digital de documentos, como apólice, certificado, fatura, boleto e endosso?</strong></v-expansion-panel-header>
                        <v-expansion-panel-content>
                            Acesse o menu “2ª Via Digital” e, após, escolha o documento no sub-menu na lateral superior direita. Ainda com dúvidas? Veja o vídeo abaixo:<br /><br />
                            <iframe width="100%" height="220" src="https://www.youtube.com/embed/WE15mSKzFm0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br>
                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header><strong>Como faço para gerar link de contratação na ponta para produtos individualizados?</strong></v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <iframe width="100%" height="220" src="https://www.youtube.com/embed/BXCYEFY0pwE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br>

                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header><strong>Como unificar acessos no Portal?</strong></v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <iframe width="100%" height="220" src="https://www.youtube.com/embed/HCZovwi80qg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br>      

                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header><strong>Como realizar movimentação de vidas?</strong></v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <iframe width="100%" height="220" src="https://www.youtube.com/embed/SvQJpHh2NsI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br>                             

            </v-flex>

            <v-flex md1></v-flex>

            <v-flex md5>
                <br>
                <h2>Pagamentos e Comprovantes</h2>
                Questões referentes as cobrança
                <br>
                <br>
                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header><strong>Como vejo minhas comissões pendentes?</strong></v-expansion-panel-header>
                        <v-expansion-panel-content>
                             Acesse o menu “Comissões” e, após, escolha o sub-menu “Pendentes” na lateral superior direita.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br>
                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header><strong>Onde encontro meus recibos de comissão?</strong></v-expansion-panel-header>
                        <v-expansion-panel-content>
                            Acesse o menu “Comissões” e, após, escolha o sub-menu “Relatório” na lateral superior direita.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br>
                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header><strong>Como solicitar segunda via do boleto?</strong></v-expansion-panel-header>
                        <v-expansion-panel-content>
                            Acesse o menu “2ª Via Digital”, após, acesse “BOLETO”.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>

    import Vue from 'vue';
    import { mapState, mapGetters } from 'vuex';
    export default {
        data() {
            return {
                caminhoRaiz: process.env.VUE_APP_API_RAIZ_ARQUIVO,
            }
        },        
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){
            this.usuario;
        }
    }
</script>
